var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCouponManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.625 15H12.375V17.625H38.625V15Z",
    fill: "#CB2110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 27.25H43V21.125C43 19.1973 41.4277 17.625 39.5 17.625H11.5C9.57227 17.625 8 19.1973 8 21.125V27.25Z",
    fill: "#804419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 36.875H39.5C41.4277 36.875 43 35.3027 43 33.375V26.375H8V33.375C8 35.3027 9.57227 36.875 11.5 36.875Z",
    fill: "#CB2110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 22C39.9832 22 40.375 21.6082 40.375 21.125C40.375 20.6418 39.9832 20.25 39.5 20.25C39.0168 20.25 38.625 20.6418 38.625 21.125C38.625 21.6082 39.0168 22 39.5 22Z",
    fill: "#FEF8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.875 8.875H14.125V17.625H36.875V8.875Z",
    fill: "#DCCCC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3125 32.5H13.6875C12.9902 32.5 12.375 31.8848 12.375 31.1875C12.375 30.4902 12.9902 29.875 13.6875 29.875H37.3125C38.0098 29.875 38.625 30.4902 38.625 31.1875C38.625 31.8848 38.0098 32.5 37.3125 32.5Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.875 32.5H14.125V42.125H36.875V32.5Z",
    fill: "#DCCCC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.875 30.75H14.125V32.5H36.875V30.75Z",
    fill: "#804419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.375 34.25H18.5V36H33.375V34.25Z",
    fill: "#804419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.875 37.75H18.5V39.5H29.875V37.75Z",
    fill: "#804419"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponManagement);
export default __webpack_public_path__ + "static/media/Coupon Management.3edeb44d20de4b5e5555d30e2540d909.svg";
export { ForwardRef as ReactComponent };